const scanForwardQuery = (start, selector) => {
	const results = document.querySelectorAll(selector);
	for (let i = 0; i < results.length; i++) {
		const elt = results[i];
		if (elt.compareDocumentPosition(start) === Node.DOCUMENT_POSITION_PRECEDING) {
			return elt;
		}
	}
};

export const hybridSelectorAll = (rootElement, selector) => {
	if (selector.indexOf('next ') === 0) {
		return [scanForwardQuery(rootElement, selector.slice(5))];
	}

	return Array.from(document.querySelectorAll(selector));
};
